import { Component } from '@angular/core';
import { LegalsFooterLinkItemBlockComponent } from '../../blocks/footer/legals-footer/legals-footer-link-block/legals-footer-link-item-block.component';

@Component({
  selector: 'app-default-dood-legal-footer',
  templateUrl: './default-dood-legal-footer.component.html',
})
export class DefaultDoodLegalFooterComponent {
  links: unknown[];

  constructor() {
    this.links = [
      {
        componentClass: LegalsFooterLinkItemBlockComponent,
        data: {
          name: 'CGV',
          link: 'https://www.dood.com/corporate/cgv/',
        },
      },
      {
        componentClass: LegalsFooterLinkItemBlockComponent,
        data: {
          name: 'CGU',
          link: 'https://www.dood.com/corporate/cgu/',
        },
      },
      {
        componentClass: LegalsFooterLinkItemBlockComponent,
        data: {
          name: 'Politique de confidentialité',
          link: 'https://www.dood.com/corporate/politique-de-confidentialite/',
        },
      },
      {
        componentClass: LegalsFooterLinkItemBlockComponent,
        data: {
          name: 'Mentions légales',
          link: 'https://www.dood.com/corporate/mentions-legales/',
        },
      },
    ];
  }
}
